module.exports = __webpack_public_path__ + "media/images/qr/graphic-qr-colour-5eced163ce2fd5bd15a9b0ad2e5c730d.svg";